<template>
    <div id="supplier-dashboard">

    </div>
</template>
<script>
export default {

}
</script>